import { ImageConstant, isDownloadEnabled, MEDICAL_CALCULATOR_DOWNLOADABLE } from '@shalina-app/shared';
import styles from '../calculator.module.scss';
import CircularProgress from '@mui/material/CircularProgress';


type CriticalCriteriaProps = {
  data: any[];
  guestUser: string | boolean | null;
  isOffline: string | boolean;
  handleArrowClick: (url: string, name: string) => void;
  handleDownload: (url: string, name: string, tid: string) => void;
  downloadingId: string | null;
  downloadedIds: string[];
};

export const CriticalCriteria: React.FC<CriticalCriteriaProps> = ({
  data,
  guestUser,
  isOffline,
  handleArrowClick,
  handleDownload,
  downloadingId,
  downloadedIds,
}) => {
  const { DownloadIcon, DropDownArrowIcon } = ImageConstant.SVG_ICONS;

  return (
    <div className={styles.calcList}>
      {data.map((item) => {
        const isDownloadable = isDownloadEnabled(item, guestUser, isOffline);

        return (
          <div
            key={item?.tid || item?.name}
            className={styles.calcListItem}
            onClick={() => handleArrowClick(item?.field_url, item?.name)}
          >
            <span className={styles.calctext}>
              <div>{item?.name}</div>
              <div>{item?.field_description}</div>
            </span>

            <span className={styles.calciconGroup}>
              {isDownloadable && (
                <span
                  className={`${styles.downloadIcon}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (!downloadedIds.includes(item?.tid)) {
                      handleDownload(item?.field_url, item?.name, item?.tid);
                    }
                  }}
                  style={{
                    opacity: downloadedIds.includes(item?.tid) ? 0.5 : 1,
                    pointerEvents: downloadedIds.includes(item?.tid) ? 'none' : 'auto',
                    position: 'relative',
                  }}
                >
                  {downloadingId === item?.tid ? (
                    <span className={styles.downloadLoader}>
                     <CircularProgress
                       size={20}
                       thickness={4}
                       sx={{
                         color: 'var(--secondaryOrange)',
                       }}
                     />
                   </span>
                  ) : (
                    <DownloadIcon />
                  )}
                </span>
              )}
              <span className={styles.arrowIcon}>
                <DropDownArrowIcon />
              </span>
            </span>
          </div>
        );
      })}
    </div>
  );
};

